module.exports = __webpack_public_path__ + "static/media/24.524e5e50.png";